import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import background from '../../../assets/login-background.jpg';
import FormControl from "@mui/material/FormControl";

export const Wrapper = styled(Box)(() => ({
    display: "flex",
    height: '100vh',
}));

export const LeftSide = styled(Box)(() => ({
    display: "flex",
    width: '50vw',
    alignItems: "end",
    justifyContent: 'center',
    paddingRight: '120px',
    flexDirection: 'column',
}));

export const RightSide = styled(Box)(() => ({
    display: "flex",
    width: '50vw',
    justifyContent: 'center',
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    color: "white",
    paddingLeft: '120px',
    flexDirection: 'column',
}));

export const StyledLoginField = styled(TextField)(() => ({
    marginTop: '24px',
    width: '380px'
}));

export const StyledPasswordField = styled(FormControl)(() => ({
    marginTop: '24px',
    width: '380px'
}));

export const StyledButton = styled(Button)(() => ({
    marginTop: '24px',
}));